import { useEffect } from "react";
import { useGuideUpdatesUnread } from "@/hooks/useGuideUpdatesRealtime";

interface Props {
  onCountChange?: (count: number) => void;
}

export function GlobalGuideUpdatesNotifier({ onCountChange }: Props) {
  const { count } = useGuideUpdatesUnread();

  useEffect(() => {
    onCountChange?.(count);
  }, [count, onCountChange]);

  return null;
}
